import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { Euler, useLoader, Vector3 } from "@react-three/fiber";
import { useRef } from "react";
import { CenteredCylinder } from "../base/CenteredCylinder";

type CarProps = {
    pos?: Vector3,
    euler?: Euler
}


export const Car = (props: CarProps) => {
    const chassis = useLoader(STLLoader, "/stl/car/chassis.stl");
    const steeringRack = useLoader(STLLoader, "/stl/car/steering_rack.stl");
    const steeringGear = useLoader(STLLoader, "/stl/car/gear.stl");
    const suspensionPart1 = useLoader(STLLoader, "/stl/car/suspension_part1.stl");
    const suspensionPart2 = useLoader(STLLoader, "/stl/car/suspension_part2.stl");

    const ref = useRef();

    return (
        <>
            <group position={props.pos} rotation={props.euler}>
                {/* The chassis. */}
                <mesh ref={ref} position={[0, 0.2, 0]}>
                    <primitive object={chassis} attach="geometry" />
                    <meshStandardMaterial
                        color={[1, 0, 0]}
                        transparent
                        opacity={0.4} />
                </mesh>

                <mesh ref={ref} position={[0, 0.14, 0.001]}>
                    <boxBufferGeometry attach="geometry" args={[0.008, 0.02, 0.006]} />
                    <meshStandardMaterial color={[0, 0, 0]} />

                    <CenteredCylinder position={[0, 0.02, 0]} color={[0.4, 0.4, 0.4]} rotation={[0, 0, 0]} radius={0.0025} height={0.015} />
                </mesh>

                <group position={[0, -0.12, -0.03]}>
                    <CenteredCylinder
                        color={[0.6, 0.6, 0.6]}
                        rotation={[1.57, 0, 1.57]}
                        radius={0.015}
                        height={0.12} />

                    <CenteredCylinder
                        position={[0.105, 0, 0]}
                        color={[0, 0, 0]}
                        rotation={[1.57, 0, 1.57]}
                        radius={0.035}
                        height={0.01} />

                    <CenteredCylinder
                        position={[-0.105, 0, 0]}
                        color={[0, 0, 0]}
                        rotation={[1.57, 0, 1.57]}
                        radius={0.035}
                        height={0.01} />
                </group>

                {/* The steering gear. */}
                <mesh ref={ref} position={[0, 0.175, 0.001]} rotation={[0, 0.16, 0]}>
                    <primitive object={steeringGear} attach="geometry" />
                    <meshStandardMaterial
                        color={[0.749, 0.749, 0.749]} />
                </mesh>

                {/* Wheel three suspension. */}
                <mesh ref={ref} position={[0.08, 0.135, -0.03]}>
                    <primitive object={suspensionPart1} attach="geometry" />
                    <meshStandardMaterial
                        color={[0.749, 0.749, 0.749]} />

                    <mesh ref={ref} position={[0.036, 0.01, 0]}>
                        <primitive object={suspensionPart2} attach="geometry" />
                        <meshStandardMaterial
                            color={[0.749, 0.749, 0.749]} />

                        <CenteredCylinder
                            position={[0.01, -0.005, 0.005]}
                            color={[0, 0, 0]}
                            rotation={[1.57, 0, 1.57]}
                            radius={0.035}
                            height={0.008} />

                        <mesh ref={ref} position={[-0.116, 0.03, 0.01]}>
                            <primitive object={steeringRack} attach="geometry" />
                            <meshStandardMaterial
                                color={[0.749, 0.749, 0.749]} />
                        </mesh>
                    </mesh>
                </mesh>

                {/* Wheel four suspension. */}
                <mesh ref={ref} position={[-0.08, 0.135, -0.02]} rotation={[3.14, 0, 3.14]}>
                    <primitive object={suspensionPart1} attach="geometry" />
                    <meshStandardMaterial
                        color={[0.749, 0.749, 0.749]} />

                    <mesh ref={ref} position={[0.036, 0.01, 0]}>
                        <primitive object={suspensionPart2} attach="geometry" />
                        <meshStandardMaterial
                            color={[0.749, 0.749, 0.749]} />

                        <CenteredCylinder
                            position={[0.01, -0.005, 0.005]}
                            color={[0, 0, 0]}
                            rotation={[1.57, 0, 1.57]}
                            radius={0.035}
                            height={0.008} />
                    </mesh>
                </mesh>

            </group>

        </>
    );
};

